import React, { useEffect, useState } from "react";
import useForm from "../../../hooks/useForm";
import useMutation from "../../../hooks/useMutation";
import Input from "../../../components/form/Input";
import Button from "../../../components/form/Button";
import Select from "../../../components/form/Select"; // Assuming you have this
import { resourceAddEdit } from "../../../services/resource";
import FileUploadSingle from "../../../components/form/FileUploadSingle";

const validation = {
  name: {
    required: true,
    message: "Resource name is required",
  },
  categoryType: {
    required: true,
    message: "Category type is required",
  },
};

function ManageResource({ getResponse = () => {}, close = () => {}, data }) {
  const {
    values,
    handleChange,
    handleSubmit,
    errors,
    setFieldsValue,
    formValidate,
  } = useForm({
    validationRules: validation,
    initialState: { contentDataType: "file" },
  });

  useEffect(() => {
    if (data?._id) {
      setFieldsValue({
        ...data,
        content: data?.content?.url,
        contentDataType: data?.contentLink ? "url" : "file",
      });
    }
  }, [data?._id]);

  const {
    mutate,
    error,
    isPending: isLoading,
  } = useMutation({
    mutationFn: async (val) => {
      const payload = {
        ...val,
        ...(data?._id && { id: data?._id }),
      };

      delete payload?.createdBy;
      delete payload?.createdAt;

      if (val?.contentDataType === "file") {
        delete payload?.contentLink;
      } else {
        delete payload?.content;
      }

      delete payload?.contentDataType;

      return await resourceAddEdit(payload);
    },
    onSuccess: (res) => {
      getResponse(res);
    },
    onError: (error) => {
      console.log(error);
    },
  });

  return (
    <div>
      <form
        onSubmit={(event) => handleSubmit(event, mutate)}
        encType="multipart/form-data"
      >
        <div className="grid grid-cols-4 gap-x-4 gap-y-4">
          <div className="relative col-span-4">
            <Input
              label={"Name"}
              inputPlaceholder={"Enter resource name"}
              inputName="name"
              value={values?.name || ""}
              onChange={handleChange}
              {...formValidate(errors, "name")}
            />
          </div>
          <div className="relative col-span-4">
            <Input
              label={"Description"}
              inputPlaceholder={"Enter description"}
              inputName="description"
              value={values?.description || ""}
              onChange={handleChange}
              {...formValidate(errors, "description")}
            />
          </div>
          <div className="relative col-span-4">
            <Select
              label="Select Category Type"
              name="categoryType"
              selectedValue={values?.categoryType}
              placeholder={"Select Category"}
              dropdownData={[
                { name: "Guide", value: "guide" },
                { name: "FAQ", value: "faq" },
                { name: "Writing Tip", value: "writing_tip" },
                { name: "External Resource", value: "external_resource" },
                { name: "Help", value: "help" },
              ]}
              setSelectedValue={(val) =>
                handleChange({
                  target: { name: "categoryType", value: val },
                })
              }
              {...formValidate(errors, "categoryType")}
            />
          </div>
          <div className="relative col-span-4">
            <Select
              label="Select Content Type"
              name="contentType"
              selectedValue={values?.contentDataType}
              dropdownData={[
                { name: "Content File", value: "file" },
                { name: "Content URL", value: "url" },
              ]}
              setSelectedValue={(val) => {
                handleChange({
                  target: { name: "contentDataType", value: val },
                });
              }}
            />
          </div>
          {values?.contentDataType === "file" ? (
            <div className="relative col-span-4">
              <FileUploadSingle
                placeholder={"Choose File (pdf)"}
                size="small"
                value={values?.content}
                onChange={(file) =>
                  handleChange({
                    target: {
                      name: "content",
                      value: file,
                    },
                  })
                }
              />
            </div>
          ) : (
            <div className="relative col-span-4">
              <Input
                label={"Content URL"}
                inputPlaceholder={"Enter content link"}
                inputName="contentLink"
                value={values?.contentLink || ""}
                onChange={handleChange}
              />
            </div>
          )}
        </div>

        <div className="relative col-span-4 mt-5">
          <div className="flex items-center justify-center gap-4">
            <Button
              buttonType="submit"
              buttonLabel={"Save Resource"}
              buttonClasses={
                "!rounded-full !px-8 !h-12 !border !border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white"
              }
              buttonLabelClasses={"mx-auto"}
              {...(isLoading && {
                loading: true,
                buttonIconPosition: "left",
                isDisable: true,
              })}
            />
            <Button
              buttonLabel={"Cancel"}
              buttonClasses={
                "!rounded-full !px-8 !h-12 !border !border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white"
              }
              buttonLabelClasses={"mx-auto"}
              buttonFunction={close}
            />
          </div>
        </div>
      </form>
    </div>
  );
}

export default ManageResource;
